import { CONTAINERS_LIST } from 'shared/enums';
import { MAIN_NAVIGATION_ACTIONS } from './constants';
import { ActionTypes } from './actions';

const initialState: CONTAINERS_LIST = CONTAINERS_LIST.EPS;

const selectedContainerReducer = (
  state = initialState,
  action: ActionTypes,
): CONTAINERS_LIST => {
  switch (action.type) {
    case MAIN_NAVIGATION_ACTIONS.SET_CONTAINER_FULFILLED:
      return action.payload;
    default:
      return state;
  }
};

export default selectedContainerReducer;
